<div class="container">
    <filter-panel [config]="filterConfig"></filter-panel>
    <!-- 19.1 hide the feature -->
    <!-- <div class="row">
        <tam-field-selector [config]="fieldConfig"></tam-field-selector>
    </div> -->
    <div class="row filter-apply">
        <button tam-button tid="filter-apply" [tamType]="'primary'" [tamSize]="'normal'" (click)="onApply()"
            [disabled]="disabled||isProgressing" [tamLoading]="isProgressing">Apply</button>
    </div>
</div>